<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Container, Radio, Text } from '@Shelly/shelly-design-system';
	import SettingGuide from '../../../SettingGuide.svelte';

	export let value: string;
	export let deferSave = false;

	const inputOptions = [
		{
			id: 'momentary',
			title: $format('option_plug_button_attached', { default: 'Attached' }),
			description: $format('option_plug_button_attached_desc', {
				default: 'The button on the plug turns the socket on and off.',
			}),
			legacy: $format('option_attached', { default: 'attached' }),
		},
		{
			id: 'detached',
			title: $format('option_plug_button_detached', { default: 'Detached' }),
			description: $format('option_plug_button_detached_desc', {
				default:
					'The button does nothing. Control the socket from the app, schedules, and automations.',
			}),
			legacy: $format('option_detached', { default: 'detached' }),
		},
	];

	const setValue = (next: string) => {
		value = next;
	};
</script>

{#if deferSave}
	<SettingGuide
		title={$format('settings_heading_plug_button', { default: 'Plug button' })}
		text={$format('settings_guide_plug_button', {
			default:
				'The button on the plug can turn the socket on and off, or be ignored so only the app and automations control it.',
		})}
	/>
	<Container padding="s" type="borderSolid" backgroundColor="color-base">
		{#each inputOptions as option (option.id)}
			<Radio
				size="m"
				bind:selected={value}
				value={option.id}
				class="mb-s"
				on:click={() => setValue(option.id)}
				id={`radio-plug-button-${option.id}`}
				info={option.description}
			>
				{option.title}
			</Radio>
		{/each}
	</Container>
{:else}
	<Text styleType="body-small" class="mb-s"
		>{$format('input_type_desc', { default: 'Set input type' })}</Text
	>
	{#each inputOptions as option (option.id)}
		<Radio
			size="m"
			selected={option.id}
			value={value}
			on:click={() => setValue(option.id)}
			id={`radio-plug-button-legacy-${option.id}`}>{option.legacy}</Radio
		>
	{/each}
{/if}
